import { useEffect, useRef, useState } from 'react';

import { getWelcome } from '@/components/onboarding/welcomeFlow';
import { useKnowledgeOperationProgress } from '@/contexts/KnowledgeOperationProgressContext';
import { useWorkspace } from '@/contexts/WorkspaceContext';

/**
 * Claims the exact operation created by onboarding as soon as the newly
 * provisioned domain becomes available to WorkspaceProvider. The operation ID is
 * the map key in the global tracker, so restoration and this immediate handoff
 * converge on one visible operation rather than two progress owners.
 */
export function OnboardingOperationTracker() {
    const [welcome] = useState(getWelcome);
    const { selectedDomain, selectedWorkspaceId, selectedWorkspace } = useWorkspace();
    const { trackOperation } = useKnowledgeOperationProgress();
    const trackedOperationId = useRef<string | null>(null);

    useEffect(() => {
        const operation = welcome?.knowledgeOperation;
        if (
            !operation ||
            !selectedWorkspaceId ||
            selectedWorkspace?.pathPrefix !== '/' ||
            selectedDomain !== welcome.domain ||
            trackedOperationId.current === operation.operationId
        ) {
            return;
        }

        trackedOperationId.current = operation.operationId;
        void trackOperation(
            {
                operation_id: operation.operationId,
                status: 'queued',
                status_url: `/admin/knowledge/operations/${operation.operationId}`,
                deduplicated: false,
            },
            {
                workspaceId: selectedWorkspaceId,
                operationType: 'website_full_refresh',
                sourceScope: 'scrape',
            }
        ).catch(() => undefined);
    }, [selectedDomain, selectedWorkspaceId, selectedWorkspace, trackOperation, welcome]);

    return null;
}
